'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/tutorial", "/tutorial/list");
  $stateProvider
    .state('tutorial', {
      url: '/tutorial',
      template: require('./tutorial.html'),
      authenticate: true
    })
    .state('tutorial.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'TutorialListController',
      controllerAs: 'tListCtrl'
    })
    .state('tutorial.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'TutorialAddController',
      controllerAs: 'tAddCtrl'
    })
    .state('tutorial.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'TutorialEditController',
      controllerAs: 'tEditCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/tutorial/tutorial.routes.js